<template>
  <div class="collapse-container">
    <div
      :aria-controls="key"
      :aria-expanded="model ? 'true' : 'false'"
      class="fit-content d-flex"
      :class="{ pointer: !disabled }"
      @click="toggle"
    >
      <div class="collapse-icon rounded-circle text-white">
        <i
          class="far "
          :class="{
            'fa-chevron-down': model,
            'fa-chevron-right': !model,
          }"
        />
      </div>
      <div class="ml-2 font-weight-bold">
        {{ title }}
      </div>
    </div>
    <b-collapse :id="key" class="my-3" :visible="model">
      <slot />
    </b-collapse>
  </div>
</template>

<script>
export default {
  name: 'SimpleCollapse',
  inject: ['registerCollapse', 'notifyCollapse'],
  props: {
    value: {
      type: Boolean,
      default: () => null,
    },
    disabled: {
      type: Boolean,
      default: () => false,
    },
    title: {
      type: String,
      required: true,
    },
    divider: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    const uid =
      crypto?.randomUUID?.() ||
      Math.random()
        .toString(36)
        .slice(2);
    return {
      opened: true,
      key: `collapse-${uid}`,
      id: `cid-${uid}`,
      unregister: null,
    };
  },
  computed: {
    model: {
      get() {
        return [true, false].includes(this.value) ? this.value : this.opened;
      },
      set(val) {
        if ([true, false].includes(this.value)) this.$emit('input', val);
        else this.opened = val;
      },
    },
  },
  mounted() {
    this.unregister = this.registerCollapse(
      this.id,
      () => this.model,
      (open) => this._setOpenInternal(open)
    );
    this.notifyCollapse(this.id, this.model);
  },
  beforeDestroy() {
    this.unregister && this.unregister();
  },
  methods: {
    toggle() {
      if (this.disabled) return;
      this.model = !this.model;
      this.$emit('toggled', this.model);
      this.notifyCollapse(this.id, this.model);
    },
    setOpen(val) {
      this._setOpenInternal(val);
    },
    _setOpenInternal(val) {
      if (this.disabled) return;
      this.model = !!val;
      this.$emit('toggled', this.model);
      this.notifyCollapse(this.id, this.model);
    },
  },
};
</script>
<style scoped>
.fit-content {
  width: fit-content;
}
.pointer {
  cursor: pointer;
}
.collapse-icon {
  width: 1.5rem;
  height: 1.5rem;
  text-align: center;
  border: 1px solid #ffffff;
  background-color: #2db782;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.2);
}
.divider {
  margin: 30px -10px !important;
}

.collapse-container {
  background-color: #fafafa;
  padding: 15px;
  margin-bottom: 10px;
}
</style>
